import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { NgxSpinnerModule } from 'ngx-spinner';
import { AddressRoutingModule } from './address-routing.module';
import { AddressAddComponent } from './components/address-add/address-add.component';
import { AddressFormComponent } from './components/address-form/address-form.component';
import { AddressListComponent } from './components/address-list/address-list.component';
import { AddressMainComponent } from './components/address-main/address-main.component';
import { AddressMapComponent } from './components/address-map/address-map.component';
import { DeliverSelectorComponent } from './components/deliver-selector/deliver-selector.component';
import { SalepointSelectorComponent } from './components/salepoint-selector/salepoint-selector.component';
import { HoursFormatPipe } from './pipes/hours-format.pipe';

@NgModule({
  declarations: [
    AddressMainComponent,
    AddressFormComponent,
    AddressMapComponent,
    AddressAddComponent,
    AddressListComponent,
    DeliverSelectorComponent,
    SalepointSelectorComponent,
    HoursFormatPipe,
  ],
  imports: [
    CommonModule,
    AddressRoutingModule,
    ReactiveFormsModule,
    GoogleMapsModule,
    FormsModule,
    NgxSpinnerModule,
  ],
  exports: [AddressMainComponent, DeliverSelectorComponent],
})
export class AddressModule { }
